import { Route, Routes } from 'react-router-dom'
import Campaign from 'features/csr/pages/Campaign'
import Donation from 'features/csr/pages/Donation'
import Home from 'features/home/pages/Home'
import Information from 'features/information/pages/Information'
import News from 'features/news/pages/News'
import Recruit from 'features/recruit/pages/Recruit'
import Service from 'features/service/pages/Service'
import ScrollToTop from 'shared/components/common/ScrollToTop'

const DataUniversRoute = () => {
  return (
    <ScrollToTop>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="information" element={<Information />}></Route>
        <Route path="service" element={<Service />}></Route>
        <Route path="csr/donation" element={<Donation />}></Route>
        <Route path="csr/campaign" element={<Campaign />}></Route>
        <Route path="news" element={<News />}></Route>
        <Route path="recruit" element={<Recruit />}></Route>
      </Routes>
    </ScrollToTop>
  )
}

export default DataUniversRoute
